// extracted by mini-css-extract-plugin
var _1 = "errorIcon__wNI4k";
var _2 = "message__qbcqa";
var _3 = "serverErrorDetails__Xhyjb";
export { _1 as "errorIcon", _2 as "message", _3 as "serverErrorDetails" }
